import Filter from "./filter"

export default class SwitchableValue<T> {
    value: T

    enable: boolean

    constructor(value: T, enable: boolean) {
        this.value = value
        this.enable = enable
    }

    public static of<Type>(value: Type, enable: boolean) {
        return new SwitchableValue(value, enable)
    }

    public static disable<Type>(value: Type) {
        return SwitchableValue.of(value, false)
    }

    public static enable<Type>(value: Type) {
        return SwitchableValue.of(value, true)
    }

    public static isValid(value: SwitchableValue<any>): boolean {
        if (value.enable === true) {
            return !Filter.isEmptyValues(value.value)
        }
        return true
    }
}
